import { render, staticRenderFns } from "./InviteTeacher.vue?vue&type=template&id=6b159be6&scoped=true&"
import script from "./InviteTeacher.vue?vue&type=script&lang=js&"
export * from "./InviteTeacher.vue?vue&type=script&lang=js&"
import style0 from "./InviteTeacher.vue?vue&type=style&index=0&id=6b159be6&lang=scss&scoped=true&"
import style1 from "./InviteTeacher.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b159be6",
  null
  
)

export default component.exports